import type { FunctionComponent, ReactNode } from "react";
import { LiveIcon } from "./LiveIcon";
import { BaseballDiamond } from "./BaseballDiamond";
import { SVGProps } from "react-html-props";
import { LoadedIconProps } from "../types";

export type CustomIconProps = SVGProps & { fill?: string; secondaryfill?: string; width?: number | string; height?: number | string; options?: Record<string, any>, elementTiming?: string };
export type GeneratedIconType = ({fill, secondaryfill, width, height, options}: CustomIconProps) => ReactNode;

export const customIcons: Record<string, FunctionComponent<CustomIconProps>> = {
    "icon_ui_live_animated": LiveIcon,
    "icon_ui_baseball_diamond": BaseballDiamond,
}